"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const lodash_1 = __importDefault(require("lodash"));
const shortCode_1 = __importDefault(require("../../libs/shortCode"));
class MerchantApi {
    constructor(api) {
        this.api = api;
    }
    getMerchant() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/m/merchant/');
            return response.data;
        });
    }
    // 更改餐廳的 name, desc, contact, address
    updateInfo(info) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/info', info);
            return response.data;
        });
    }
    updateMerchantImage(type, file) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('type', type);
            formData.append('file', file);
            /** @type {AxiosResponse} */
            const response = yield this.api.axiosNode.post('/m/merchant/image', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        });
    }
    removeMerchantImage(type) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.delete(`/m/merchant/image/${type}`);
            return response.data;
        });
    }
    // 更改服務費
    updateSurcharge(surcharge) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/surcharge', surcharge);
            return response.data;
        });
    }
    // 更改小數處理
    updateRounding(rounding) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/rounding', rounding);
            return response.data;
        });
    }
    // 更改用戶介面語言，例如 locales: ['zh', 'en']
    updateClientLocales(locales) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/locales', { locales });
            return response.data;
        });
    }
    // 更改用戶介面預設語言，例如 language: 'zh'
    updateClientDefaultLanguage(language) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/defaultclientlanguage', { value: language });
            return response.data;
        });
    }
    // 更改廚房單預設語言，例如 language: 'zh'
    updateBatchPrintLanguage(language) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/batchlocale', { locale: language });
            return response.data;
        });
    }
    // 開關叫侍應功能
    updateWaiterEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/waiter', { enabled });
            return response.data;
        });
    }
    // 開關動態 QRCode 功能
    updateDynamicQRCodeEnable(dynamic) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/qrcode', { dynamic });
            return response.data;
        });
    }
    // 更改動態 QRCode 自訂顯示文字
    updateDynamicQRCodeCustomText(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/qrcustomtext', { value });
            return response.data;
        });
    }
    // 更改動態 QRCode 不須輸入人數
    updateDynamicQRCodeDisableCustomerCount(disableCustomerCount) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/qrdisablecustomercount', { value: disableCustomerCount });
            return response.data;
        });
    }
    // 更改外賣最快取餐時間（分鐘）
    updateTakeawayPickupAfterMinutes(minutes) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/takeawaypickupafter', { minutes });
            return response.data;
        });
    }
    // 更改結帳後自動打印收據開關
    updateAutoPrintReceipt(autoPrintReceipt) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/autoprintreceipt', { value: autoPrintReceipt });
            return response.data;
        });
    }
    // 更改自訂推薦文字
    updateRecommendCustomText(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/recommendcustomtext', { value });
            return response.data;
        });
    }
    // 更改精簡模式(列印?)
    updateLitePrinting(litePrinting) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/liteprinting', { value: litePrinting });
            return response.data;
        });
    }
    // 更改啟用餐單編號
    updateEnableCode(enable) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/code', { value: enable });
            return response.data;
        });
    }
    // 更改頁腳自訂文字
    updateFooterCustomText(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/footercustomtext', { value });
            return response.data;
        });
    }
    // 更改營業時間設定 openings 為7天的 array，每天可以設定多個 IMerchantOpeningSetting
    updateOpening(openings) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = immer_1.produce(openings, (draft) => {
                lodash_1.default.forEach(draft, dayConfigs => {
                    dayConfigs.forEach(config => {
                        if (typeof config.surcharge === 'object') {
                            config.surcharge = lodash_1.default.get(config, 'surcharge.percent');
                        }
                    });
                });
                return draft;
            });
            const response = yield this.api.axiosGo.post('/m/merchant/opening', data);
            return response.data;
        });
    }
    updatePayFirst(payFirst) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/payfirst', { value: payFirst });
            return response.data;
        });
    }
    // 新增/修改/刪除一個 payment，根據 key 決定，如果不存在就會建立，如果有給 remove: true 就會刪除
    updatePayment(payment) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const data = {
                key: (_a = payment.key) !== null && _a !== void 0 ? _a : shortCode_1.default.generate(7),
                name: payment.name,
                amount: (_b = payment.amount) !== null && _b !== void 0 ? _b : 0,
                percent: (_c = payment.percent) !== null && _c !== void 0 ? _c : 0,
                remove: (_d = payment.remove) !== null && _d !== void 0 ? _d : false,
                extra: (_e = payment.extra) !== null && _e !== void 0 ? _e : false,
                tips: (_f = payment.tips) !== null && _f !== void 0 ? _f : false,
            };
            const response = yield this.api.axiosGo.post('/m/merchant/payment', data);
            return response.data;
        });
    }
    // 新增/修改/刪除一個 payment，根據 key 決定，如果不存在就會建立，如果有給 remove: true 就會刪除
    updateShipping(shipping) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const data = {
                key: (_a = shipping.key) !== null && _a !== void 0 ? _a : shortCode_1.default.generate(7),
                name: shipping.name,
                cost: shipping.cost,
                discount: shipping.discount,
                enabled: shipping.enabled,
                freightCollect: shipping.freightCollect,
                maxDeliveryMinute: (_b = shipping.maxDeliveryMinute) !== null && _b !== void 0 ? _b : 0,
                minAmount: (_c = shipping.minAmount) !== null && _c !== void 0 ? _c : 0,
                minDeliveryMinute: (_d = shipping.minDeliveryMinute) !== null && _d !== void 0 ? _d : 0,
                remove: (_e = shipping.remove) !== null && _e !== void 0 ? _e : false,
                type: shipping.type,
            };
            const response = yield this.api.axiosGo.post('/m/merchant/shipping', data);
            return response.data;
        });
    }
    // 新增 table group
    createTablegroup(group) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/tablegroup', { group });
            return response.data;
        });
    }
    // 刪除 table group
    deleteTablegroup(group) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/tablegroup', { group, remove: true });
            return response.data;
        });
    }
    // 新增 table 或修改 table 的 group
    updateTable(table, group) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/table', { table, group });
            return response.data;
        });
    }
    // 刪除 table
    deleteTable(table) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/table', { table, remove: true });
            return response.data;
        });
    }
    getUiVersion(client) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/s/health/version', { client: client });
            return response.data;
        });
    }
    updateCategoryOrder(parentCategoryId, categoryIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.axiosGo.post('/m/merchant/sort/category', {
                parentCategoryId,
                categoryIds,
            });
        });
    }
    updateCategoryPrinterOrder(categoryIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.axiosGo.post('/m/merchant/sort/print', {
                categoryIds,
            });
        });
    }
    updatePromoteOrder(menuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.axiosGo.post('/m/merchant/sort/promote', {
                menuIds,
            });
        });
    }
    updateSetOrder(categoryId, setIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.axiosGo.post('/m/merchant/sort/set', {
                categoryId,
                setIds,
            });
        });
    }
    updateMenuOrder(categoryId, menuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.axiosGo.post('/m/merchant/sort/menu', {
                categoryId,
                menuIds,
            });
        });
    }
    updateSetmenuOrder(categoryId, setMenuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.axiosGo.post('/m/merchant/sort/setmenu', {
                categoryId,
                menuIds: setMenuIds,
            });
        });
    }
    updateCategoryTagOrder(categoryTagIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.axiosGo.post('/m/merchant/sort/categorytag', {
                categoryTagIds,
            });
        });
    }
    toggleTakeawayDisabled(disabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('m/merchant/takeaway', { disabled: disabled });
            return response.data;
        });
    }
}
exports.default = MerchantApi;
//# sourceMappingURL=Merchant.js.map